export const getNow = () => {
  //return new Date('2025-05-02T16:20:00Z')
  return new Date()
}
